module.exports = __webpack_public_path__ + "static/media/incidents-legend.ff97f9f4.jpg";